<template>
  <div class="contract-hotel-card-container">
    <div class="contract-hotel-card-image-container">
      <div
        v-if="transportationProvided"
        class="mobile-featured-bar"
      >
        {{ $t('h4h.featuredWithTransportation') }}
      </div>
      <div
        v-else
        class="mobile-featured-bar"
      >
        {{ $t('h4h.featured') }}
      </div>
      <ImageSlider
        :hotelid="parseInt(hotel.id)"
        :images="hotel.images"
      />
      <div
        v-if="notEnoughRooms"
        class="contract-rooms-remaining"
      >
        <span>
          Only {{ hotel.inventory_on_site }} Rooms Remaining
        </span>
      </div>
    </div>
    <div class="contract-hotel-details">
      <div class="contract-hotel-title">
        <h4>{{ hotel.name }}</h4>
      </div>
      <p>{{ hotel.fullAddress }}</p>
      <p v-if="hotel.directions">
        {{ hotel.directions.distance.text }} to {{ this.$store.state.hotel.venue }}
      </p>
    </div>
    <div class="contract-hotel-purchasing">
      <div class="contract-hotel-pricing">
        <span class="price ">
          <CurrencyConvert
            :amount="(price / hotel.stayDuration)*rate"
            :usd="price / hotel.stayDuration"
            :currency="currency"
          />
        </span>
        <span>
          {{ $t('h4h.perNight') }}
        </span>
        <span class="dates">
          <CurrencyConvert
            :amount="price * rate"
            :usd="price"
            :currency="currency"
          />
          {{ getTotalForStay() }}
        </span>
      </div>
      <div class="contract-hotel-show-btn">
        <div
          class="btn btn-secondary room-select-btn"
          @click="selectSpecifiedHotel(hotel)"
        >
          {{ $t('h4h.chooseRoom') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global locale */

/* eslint-disable vue/prop-name-casing */
import ImageSlider from '../../image_slider'
import Hotel from '../../../classes/hotel'
import { CurrencyConvert } from '../../../default/currency_convert'
import { mapGetters, mapMutations } from 'vuex'
import moment from 'moment'
import {trackHotelIndex, trackHotelOverview} from './shared_hotel_card_functions'

export default {
  components: {
    ImageSlider,
    CurrencyConvert
  },
  props: {
    id: {
      default: null,
      type: Number
    },
    hotel: {
      default: null,
      type: Hotel
    },
    rate: {
      default: 1,
      type: Number
    },
    currency: {
      default: 'USD',
      type: String
    }
  },

  computed: {
    ...mapGetters('hotel', [
      'getLowestValue',
      'getTBDStatus'
    ]),
    price() {
      return this.getLowestValue(this.hotel.id)
    },
    transportationProvided(){
      return this.hotel.transportationFee > 0 ? true : false
    },
    notEnoughRooms() {
      return this.hotel.inventory_on_site <= this.$store.state.packages.packageQty
    }
  },

  methods: {
    ...mapMutations('hotel', ['selectHotel', 'deselectHotel']),

    selectSpecifiedHotel(hotel){
      this.selectHotel(hotel)
      this.manipulateHistory(hotel)

      trackHotelOverview(hotel)
    },

    manipulateHistory(hotel){
      window.history.pushState(hotel.id, null, `hotels#${hotel.id}`)
      window.addEventListener('popstate', (e)=>{
        if(e.state !== null) {
          this.selectHotel(hotel)
          trackHotelOverview(hotel)
        } else {
          this.selectHotel(null)
          trackHotelIndex()
        }
      })
    },

    getTotalForStay() {
      if (this.hotel.tbdDates) {
        let wording = this.hotel.stayDuration == 1 ? 'night' : 'nights'
        return ` for ${this.hotel.stayDuration}-${wording}`
      }

      moment.locale(locale)
      return this.$t('h4h.contractedTotal', {
        checkIn: `${moment(this.hotel.checkIn).format('L')}`,
        checkOut: `${moment(this.hotel.checkOut).format('L')}`
      })
    }
  }


}

</script>
